module.exports = __webpack_public_path__ + "img/accueil_publier-commentaire.67bd6a37.png";